import { type Floor } from "@eisox/api/core-api";
import { cn } from "@eisox/design-system";

import * as RoomsSelector from "./rooms-selector";

interface ModalRoomsSelectorProps extends RoomsSelector.RoomsSelectorProps {
  floors: Floor[];
  className?: string;
  style?: React.CSSProperties;
}

const ModalRoomsSelector: React.FC<ModalRoomsSelectorProps> = ({ floors, className, style, ...props }) => (
  <div className={cn("gap-2.5 flex flex-col", className)} style={style}>
    <RoomsSelector.Root {...props}>
      <RoomsSelector.TextSearch />
      <div className={cn("gap-2.5 *:min-w-0 flex *:flex-1")}>
        <RoomsSelector.TypeSearch />
        <RoomsSelector.PlanSearch floors={floors} />
        <RoomsSelector.GroupSearch />
      </div>
    </RoomsSelector.Root>
  </div>
);

ModalRoomsSelector.displayName = "ModalRoomsSelector";

export { ModalRoomsSelector };
export type { ModalRoomsSelectorProps };
